import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FlashMessageService } from './flash-message.service';

@NgModule({
  imports: [
    MatSnackBarModule,
  ],
  providers: [
    FlashMessageService,
  ],
})
export class FlashMessageModule {
}
